export function loadRazorpayScript() {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }
    const existing = document.querySelector(
      'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
    );
    if (existing) {
      existing.addEventListener('load', () => resolve(window.Razorpay));
      existing.addEventListener('error', reject);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => reject(new Error('Failed to load Razorpay checkout'));
    document.body.appendChild(script);
  });
}

/**
 * Opens Razorpay Checkout for subscription-admin order mode and returns handler payload.
 */
export async function openRazorpayOrderCheckout({
  razorpayKeyId,
  order,
  customerId,
  charge,
  description,
  prefill = {},
  onConfirm,
  checkoutOptions = {},
}) {
  const Razorpay = await loadRazorpayScript();

  return new Promise((resolve, reject) => {
    const options = {
      key: razorpayKeyId,
      amount: order.amount,
      currency: order.currency || 'INR',
      order_id: order.id,
      name: 'Spotless AI Subscription',
      description:
        charge?.checkoutDescription ||
        charge?.billingSummary?.checkoutDescription ||
        description ||
        'Subscription payment',
      notes: charge?.billingSummary
        ? {
            amount: String(charge.billingSummary.amount),
            gst: String(charge.billingSummary.gstAmount),
            total: String(charge.billingSummary.totalAmount),
          }
        : undefined,
      prefill,
      theme: { color: '#2563eb' },
      ...(customerId ? { customer_id: customerId } : {}),
      ...checkoutOptions,
      handler: async (response) => {
        try {
          const result = await onConfirm({
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          });
          resolve(result);
        } catch (err) {
          reject(err);
        }
      },
      modal: {
        ondismiss: () => reject(new Error('Payment cancelled')),
      },
    };

    const rzp = new Razorpay(options);
    rzp.on('payment.failed', (resp) => {
      const msg =
        resp.error?.description ||
        resp.error?.reason ||
        'Payment failed. Please try again.';
      reject(new Error(msg));
    });
    rzp.open();
  });
}

export function formatInr(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(Number(amount));
}
